const legendItems = [
  { label: 'Available', colorClassName: 'bg-site-available' },
  { label: 'Reserved', colorClassName: 'bg-site-reserved' },
  { label: 'Unavailable', colorClassName: 'bg-site-unavailable' },
  { label: 'Selected', colorClassName: 'bg-site-selected' },
]

const Legend = () => (
  <div className="grid gap-3 border-t border-border/60 pt-4">
    <div className="grid gap-3">
      {legendItems.map(({ label, colorClassName }) => (
        <div key={label} className="flex items-center gap-3 text-sm text-muted-foreground">
          <span
            aria-hidden="true"
            className={`${colorClassName} h-3.5 w-3.5 rounded-xs shadow-[inset_0_0_0_1px_rgba(255,255,255,0.15)]`}
          />
          <span>{label}</span>
        </div>
      ))}
    </div>
  </div>
)

export default Legend
